import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { NonPresentPreference, NotificationSetting, PatchNotificationSettingUserSettingData, PatchUiPreferenceUserSettingData, PresentPreference, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function userSetting(config) {
    const getAllNotificationSettingsResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(NotificationSetting)),
    });
    const patchNotificationSettingResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    const getUiPreferenceResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ parsers.taggedUnion('tag', [
            ['present', PresentPreference],
            ['not-present', NonPresentPreference],
        ]))),
    });
    const patchUiPreferenceResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(async () => null),
    });
    return Object.freeze({
        /**
         * Update preferences for notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.token The token with which you want to get the preferences, if not given the preferences are retrieved for the currently logged in user.
         * @returns The preferences for the user as described by the `token`.
         */
        getAllNotificationSettings: async ({ token = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/settings/notification_settings/`, getAllNotificationSettingsResponse.v, undefined, {
                token,
            });
            return result;
        },
        /**
         * Update preferences for notifications.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @param arg.token The token with which you want to update the preferences, if not given the preferences are updated for the currently logged in user.
         * @returns Nothing.
         */
        patchNotificationSetting: async ({ requestBody, token = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/settings/notification_settings/`, patchNotificationSettingResponse.v, JSON.stringify(PatchNotificationSettingUserSettingData.encode(requestBody)), {
                token,
            });
            return result;
        },
        /**
         * Get ui preferences.
         *
         * @param arg The arguments to the function.
         * @param arg.name The name of the preference you want to get.
         * @param arg.token The token with which you want to get the preferences, if not given the preferences are retrieved for the currently logged in user.
         * @returns The preferences for the user as described by the `token`.
         */
        getUiPreference: async ({ name, token = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/settings/ui_preferences/${name}`, getUiPreferenceResponse.v, undefined, {
                token,
            });
            return result;
        },
        /**
         * Update ui preferences.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @param arg.token The token with which you want to update the preferences, if not given the preferences are updated for the currently logged in user.
         * @returns Nothing.
         */
        patchUiPreference: async ({ requestBody, token = undefined, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/settings/ui_preferences/`, patchUiPreferenceResponse.v, JSON.stringify(PatchUiPreferenceUserSettingData.encode(requestBody)), {
                token,
            });
            return result;
        },
    });
}
